export default __webpack_public_path__ + "static/media/learose3-1920w.a7a54c81.webp";